
import { Image } from 'vue-datocms'
import RichTextSection from '~/components/public/rich-text-section.vue'
import FeaturedGroup from '~/components/public/featured/featured-group.vue'
import ArrowLeftIcon from '~/assets/images/arrow-left-line-icon.svg?inline'
import WorkshopDetails from '~/components/public/workshop-details.vue'
import PublicHero from '~/components/public/public-hero.vue'

export default {
  components: {
    PublicHero,
    ArrowLeftIcon,
    RichTextSection,
    FeaturedGroup,
    'datocms-image': Image,
    WorkshopDetails,
  },
  props: {
    backLink: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      default: null,
    },
    contentSection: {
      type: Object,
      default: () => ({}),
    },
    readMoreSection: {
      type: Object,
      default: () => ({}),
    },
    metaInformation: {
      type: Object,
      default: () => ({}),
    },
    isWorkshop: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    featuredItems() {
      const { readMoreSection } = this

      return readMoreSection && readMoreSection.links ? readMoreSection.links : []
    },
    showFeaturedItems() {
      return this.featuredItems.length > 0
    },
    content() {
      const { contentSection } = this

      return contentSection.richText ? contentSection.richText : null
    },
    information() {
      return [
        ...(this.tags.length > 0
          ? [
              {
                icon: 'tag',
                label: this.$gettext('Tags'),
                value: this.tags,
              },
            ]
          : []),

        ...(this.metaInformation.lessonNumber
          ? [
              {
                icon: 'lessons',
                label: this.$gettext('Lesson'),
                value: `${this.$gettext('Lesson')} ${
                  this.metaInformation.lessonNumber
                }`,
              },
            ]
          : []),

        ...(this.metaInformation.firstPublishedAt
          ? [
              {
                icon: 'calendar',
                label: this.$gettext('Date published'),
                value: this.$formatAsDate(
                  this.metaInformation.firstPublishedAt,
                ),
              },
            ]
          : []),

        ...(this.metaInformation.readingTimeInMinutes
          ? [
              {
                icon: 'reading-time',
                label: this.$gettext('Reading time'),
                value: this.metaInformation.readingTimeInMinutes + ' min.',
              },
            ]
          : []),

        ...(this.metaInformation.dateTime
          ? [
              {
                icon: 'calendar',
                label: this.$gettext('Date and time'),
                value: this.$formatAsDate(
                  this.metaInformation.dateTime,
                  'dateTime',
                ),
              },
            ]
          : []),

        ...(this.metaInformation.location
          ? [
              {
                icon: 'location',
                label: this.$gettext('Location'),
                value: this.metaInformation.location,
              },
            ]
          : []),
      ]
    },
    tags() {
      return this.metaInformation.tags
        ? this.metaInformation.tags.map((tag) => tag.name).join(', ')
        : []
    },
  },
}
